"use strict";
/**
 * if value has been saved as a string ( tci usecase )
 * then the appropriate option needs to be found and set as
 * value in the format of { display: ..., value: ... }
 *
 * Because thats the only format our dropdowns understand
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValue_MULTI = exports.getValue_SINGLE = void 0;
var toArray_1 = require("../../../utils/toArray");
var getAllOptionsFns_1 = require("./getAllOptionsFns");
// Note: - saveValueAsString can be misleading here, because the value could be a string, integer, boolean values
// maybe we can rename to saveValueOnly, or some better name
var getValue_SINGLE = function (_a) {
    var _b;
    var valueProp = _a.valueProp, optionsFn = _a.optionsFn, options = _a.options, theme = _a.theme, saveValueAsString = _a.saveValueAsString;
    return saveValueAsString
        ? (optionsFn ? (_b = (0, getAllOptionsFns_1.getAllOptionsFns)(theme))[optionsFn.fn].apply(_b, ((0, toArray_1.toArray)(optionsFn.args) || [])) : options).find(function (d) { return d.value === valueProp; })
        : valueProp;
};
exports.getValue_SINGLE = getValue_SINGLE;
var getValue_MULTI = function (_a) {
    var valueProp = _a.valueProp, optionsFn = _a.optionsFn, options = _a.options, theme = _a.theme, saveValueAsString = _a.saveValueAsString;
    return saveValueAsString
        ? valueProp === null || valueProp === void 0 ? void 0 : valueProp.map(function (vProp) {
            var _a;
            return (optionsFn ? (_a = (0, getAllOptionsFns_1.getAllOptionsFns)(theme))[optionsFn.fn].apply(_a, ((0, toArray_1.toArray)(optionsFn.args) || [])) : options).find(function (d) { return d.value === vProp; });
        })
        : valueProp;
};
exports.getValue_MULTI = getValue_MULTI;
